// extracted by mini-css-extract-plugin
export default {"root":"group-page_root__IR4z7","groupList":"group-page_groupList__1YLJl","addUser":"group-page_addUser__3i7p-"};